<template>
  <v-autocomplete
    v-model="selected"
    :name="name"
    :box="box"
    :solo="solo"
    :error-messages="error"
    clearable
    :items="usersData"
    :label="$t(label)"
    :multiple="multiple"
    :class="inputCssClass"
    :loading="loading"
    chips
    item-text="name"
    @input="onSelected"
    item-value="id"
  ></v-autocomplete>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  props: {
    users: {
      type: Array,
    },
    inputCssClass: {
      type: [Object, String],
    },
    name: {
      type: String,
    },
    value: {
      type: [Array, String, Number],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    box: {
      type: Boolean,
    },
    solo: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: 'Clientes',
    },
    error: {
      type: String,
    },
  },
  data: () => ({
    loading: false,
    usersData: [],
    selected: [],
  }),
  mounted() {
    if (this.value) {
      this.selected = this.value;
    }
    if (this.users) {
      this.usersData = this.users;
    } else {
      this.loading = true;
      apiCtrl.get('/user/select-list').then(res => {
        this.usersData = [];
        res.data.data.forEach(element => {
          // element.user.categories = element.categories;
          this.usersData.push(element);
        });
        this.loading = false;
        // console.log(this.usersData);
      });
    }
  },
  methods: {
    onSelected() {
      this.$emit('input', this.selected);
    },
  },
  computed: {
    selectedUser() {
      return this.value || [];
    },
    //log() {
    //log = 'Computed';
    //console.log(log);
    //return log;
    //}
  },
  watch: {
    selectedUser: function(val, oldVal) {
      if (!this.selectedUser.length) {
        this.selected = [];
      } else if (this.multiple) {
        // El valor puede cambiar desde fuera (p. ej. al aplicar un filtro guardado)
        this.selected = this.selectedUser;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
